import { render, staticRenderFns } from "./Picking.vue?vue&type=template&id=5f4585b0&scoped=true"
import script from "./Picking.vue?vue&type=script&lang=js"
export * from "./Picking.vue?vue&type=script&lang=js"
import style0 from "./Picking.vue?vue&type=style&index=0&id=5f4585b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4585b0",
  null
  
)

export default component.exports